import React, { Component } from 'react';
import Location from "../headerComponents/location"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import locationIcon from "../images/icons/location.png"
import $ from "jquery";
export default class HeaderLocationSeller extends Component {
    locationClick() {
        $(".locationPopUp").show();
        $("#locationMainDiv").show();
    }
    render() {
        let themeId = localStorage.getItem('themeId')
        let hasLocation = localStorage.getItem('hasLocation');
        return (
            hasLocation === '1' ?
                <div className="locationDiv headerIcons">
                    <div onClick={this.locationClick} className="headerImage locationPicker">
                       {themeId === "28" ? <img src={locationIcon}/> :  <FontAwesomeIcon icon={faMapMarkerAlt} />} 
                    </div>
                    <div className="popupWrap locationPopUp" id="locationDiv" >
                        {window.sessionStorage.getItem('sellerId') ?
                            <Location></Location>
                            : ""}
                    </div>
                </div>
                : ''
        )
    }
}